import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker/index';
import OptionsContainer from '../../../components/OptionsContainer';
import Validate from '../../../../../components/Validation/Validate';
import { required } from '../../../../../utils/validation/validator';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import CurrencySelector from '../../../components/CurrencySelector';

export class AdditionalItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };
  render() {
    const {
      item,
      disabled,
      validatorGroup,
      validationCounter,
      removable,
    } = this.props;

    return (
      <div className="secondary-background expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="col-auto">
            <PageSectionHeader>
              <FormattedMessage {...messages.itemWithIdx} values={{ idx: this.props.index + 1 }} />
              {/* <FormattedMessage {...messages.claimed} /> */}
            </PageSectionHeader>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-5 col-sm-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.descriptionOfItem}
              fieldName={messages.descriptionOfItem}
            >
              <Textbox
                disabled={disabled}
                name="descriptionOfItem"
                type="text"
                onChange={this.onChange('descriptionOfItem')}
                value={item.descriptionOfItem}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.descriptionOfItem}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-3 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.datePurchased}
              fieldName={messages.datePurchased}
            >
              <DatePicker
                disabled={disabled}
                name="datePurchased"
                type="text"
                onDayChange={this.handleDayChange('datePurchased')}
                value={item.datePurchased}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.datePurchased}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-4 col-sm-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.storeWhereItemWasPurchased}
              fieldName={messages.storeWhereItemWasPurchased}
            >
              <Textbox
                disabled={disabled}
                name="storeWhereItemWasPurchased"
                type="text"
                onChange={this.onChange('storeWhereItemWasPurchased')}
                value={item.storeWhereItemWasPurchased}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.storeWhereItemWasPurchased}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-5 col-sm-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.purchasePrice}
              fieldName={messages.purchasePrice}
            >
              <Textbox
                disabled={disabled}
                name="purchasePrice"
                type="number"
                onChange={this.onChange('purchasePrice')}
                value={item.purchasePrice}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.purchasePrice}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-3 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currency')}
                disabled={disabled}
                value={item.currency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-4 col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.proofOfPurchaseAttached} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={disabled}
                  type="radio"
                  checked={item.proofOfPurchaseAttached === 'true'}
                  onChange={this.onChange('proofOfPurchaseAttached')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={disabled}
                  type="radio"
                  checked={item.proofOfPurchaseAttached === 'false'}
                  onChange={this.onChange('proofOfPurchaseAttached')}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-5 col-sm-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountClaimed}
              fieldName={messages.amountClaimed}
            >
              <Textbox
                disabled={disabled}
                name="amountClaimed"
                type="number"
                onChange={this.onChange('amountClaimed')}
                value={item.amountClaimed}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.amountClaimed}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-3 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountClaimedCurrency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('amountClaimedCurrency')}
                disabled={disabled}
                value={item.amountClaimedCurrency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
      </div>
    );
  }
}

AdditionalItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step10/components/Additional/AdditionalItem.js